import { Pipe } from '@angular/core';

@Pipe({ name: 'companyLogo' })
export class CompanyLogoPipe {
  transform(type?: string): string | null {
    return type ? `/assets/images/svg/logo-${type.toLowerCase()}.svg` : null;
  }
}
